// extracted by mini-css-extract-plugin
export default {"root":"OrderActionButtons_root__iyx48","toneSoft":"OrderActionButtons_toneSoft__FZ6Vm"};